import { Container, Navbar, Image, Nav } from "react-bootstrap";
import { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faTruck } from "@fortawesome/free-solid-svg-icons";
import Swal from 'sweetalert2';
import LeaveIcon from "../assets/leaveicon.png";
import Truck from "../assets/vehicle.png";

const NavbarMenu = () => {
  const employee = JSON.parse(localStorage.getItem("current_user"));
  const fullname = employee?.fullname;
  const hasOriUser = !!localStorage.getItem('ori_current_user');

  useEffect(() => {
    const navbar = document.querySelector(".navbar");
    if (navbar) {
      // Set a global CSS variable with the current height
      document.documentElement.style.setProperty(
        "--navbar-height",
        `${navbar.offsetHeight}px`
      );
    }

    // Update automatically when window is resized
    const handleResize = () => {
      if (navbar) {
        document.documentElement.style.setProperty(
          "--navbar-height",
          `${navbar.offsetHeight}px`
        );
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [fullname]); // re-calculate if username changes

  const handleBtnLogout = () => {
    Swal.fire({
      title: 'Confirm Logout?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'Cancel',
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        if(localStorage.getItem("ori_current_user")){
          
          localStorage.setItem("current_user", localStorage.getItem("ori_current_user"));
          localStorage.setItem("roles", localStorage.getItem("ori_roles"));
          localStorage.setItem("token", localStorage.getItem("ori_token"));
          localStorage.setItem("user", localStorage.getItem("ori_user"));
          localStorage.setItem("leaveData", localStorage.getItem("ori_leaveData"));

          localStorage.removeItem("ori_current_user");
          localStorage.removeItem("ori_roles");
          localStorage.removeItem("ori_token");
          localStorage.removeItem("ori_user");
          localStorage.removeItem("ori_leaveData");
        } else {
          localStorage.clear();
        }
        window.location.href = "/Login";
      }
    });
  };

  return (
    <Navbar
      expand="lg"
      fixed="top"
      className="navbar-background"
      style={{
        backgroundColor: hasOriUser
          ? 'red'
          : 'rgba(0, 0, 0, 0.85)',
        height: 'auto',
        minHeight: '60px',
        zIndex: 1000
      }}
    >
      <Container fluid className="d-flex justify-content-between align-items-center px-3" style={{ flexWrap: 'nowrap', padding: '0 1rem' }}>
        {/* Left section: Logo, Title, and Username */}
        <div className="d-flex align-items-center" style={{ minWidth: 0, flex: '1 1 auto' }}>
          <Navbar.Brand href="/" className="d-flex align-items-center text-decoration-none mb-0 flex-shrink-0">
            <Image
              src={Truck}
              // src={LeaveIcon}
              className="d-inline-block align-top me-1"
              style={{ color: 'white', width: '38px', height: '38px', marginLeft: window.innerWidth < 768 ? '0' : '8px' }}
              alt="myLeave icon"
            />
            {/* <FontAwesomeIcon
              icon={faTruck}
              style={{
                color: "#ffdab9",
                fontSize: "28px",
                marginLeft: window.innerWidth < 768 ? "0" : "8px"
              }}
            /> */}
            <span className="text-white fw-semibold fs-4 ms-1">myLeave</span>
          </Navbar.Brand>

          <span
            className="text-white ms-3 d-none d-lg-inline"
            style={{ fontSize: '20px' }}
          >
            {fullname}
          </span>

          {/* Username visible on mobile and tablet, centered and wraps if needed */}
          <div className="d-lg-none d-flex justify-content-center flex-grow-1" style={{ marginLeft: '-10px' }}>
            <span
              className="text-white text-center"
              style={{
                fontSize: '20px',
                wordBreak: 'break-word',
                overflow: 'hidden'
              }}
            >
              {fullname}
            </span>
          </div>
        </div>

        {/* Navbar Toggle Button (Hamburger icon for mobile) - Always on first line, vertically centered */}
        <Navbar.Toggle
          aria-controls="navbar-nav"
          style={{ borderColor: "#999999", padding: '6px 10px' }}
          className="ms-2 flex-shrink-0 align-self-center"
        >
          <FontAwesomeIcon icon={faBars} style={{ color: '#999999', fontSize: '1.3rem' }} />
        </Navbar.Toggle>

        {/* Navbar Links (Collapsed on mobile by default) */}
        <Navbar.Collapse id="navbar-nav" className="justify-content-end">
          <Nav className="ms-auto">
            <Nav.Link
              href="/LeaveApplicationList"
              className="fw-bold px-2"
              style={{
                color: '#7e7e7e',
                fontSize: '20px',
                whiteSpace: 'nowrap'
              }}
            >
              Apply Leave
            </Nav.Link>
            <Nav.Link
              href="/MedicalClaimList"
              className="fw-bold px-2"
              style={{
                color: '#7e7e7e',
                fontSize: '20px',
                whiteSpace: 'nowrap'
              }}
            >
              Medical Claim
            </Nav.Link>
            <Nav.Link
              onClick={handleBtnLogout}
              className="fw-bold px-2"
              style={{
                color: '#7e7e7e',
                fontSize: '20px',
                whiteSpace: 'nowrap',
                cursor: 'pointer'
              }}
            >
              Logout
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};
export default NavbarMenu;